import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4359dc5c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=4359dc5c&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=4359dc5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359dc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4359dc5c')) {
      api.createRecord('4359dc5c', component.options)
    } else {
      api.reload('4359dc5c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4359dc5c&scoped=true", function () {
      api.rerender('4359dc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabPrize/main.vue"
export default component.exports